import { useEffect, useRef } from 'react';
import { Input } from 'antd';
import clsx from 'clsx';

export default function InputFocus({
  dataIndex,
  value,
  title,
  onChange,
  className,
}) {
  const inputRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          if (inputRef.current) {
            inputRef.current.focus();
          }
        } else {
          if (inputRef.current) {
            inputRef.current.blur();
          }
        }
      },
      {
        root: null,
        threshold: 0.1,
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  return (
    <div ref={containerRef}>
      <Input
        id={dataIndex}
        ref={inputRef}
        value={value}
        name={dataIndex}
        placeholder={`${title}`}
        className={clsx('h-9 w-full rounded-[50px]', className)}
        onChange={(e) => onChange(dataIndex, e.target.value)}
      />
    </div>
  );
}
